<template>
  <div>
    <div>
        <a-collapse v-model="activeKey" expand-icon-position="right" :bordered="false">
            <a-collapse-panel v-for="(item, index) in riskInfos" :header="'计划'+(index+1)" :key="index+''" class="insure-plan">
                <plan :index="index" :disabledAll="disabledAll" :riskInfo="item" :count="count" :ref="'plan'+index" @collectData="collectData" @getPremium="getPremium" />
                <a-icon slot="extra" v-if="!disabledAll && riskInfos.length > 1" type="delete" @click.stop="deleteInsurePlan(index)" />
                <a-button type="danger" v-if="!disabledAll && riskInfos.length > 1" @click="deleteInsurePlan(index)">删除计划</a-button>
            </a-collapse-panel>
        </a-collapse>
        <a-button type="primary" @click="addInsurePlan" v-if="!disabledAll">新建保障计划</a-button>
    </div>
    <a-form-model layout="horizontal" :model="form" :colon="false" ref="planForm" :label-col="{ span: 3 }" :wrapper-col="{ lg: 6, sm: 8 }">
        <a-form-model-item label="总保费">
            <a-input v-model="form.totalPremium" :disabled="disabledAll" suffix="元" read-only></a-input>
        </a-form-model-item>
        <a-form-model-item>
            <a-button v-if="!disabledAll" type="primary" @click="getPremium">计算保费</a-button>
        </a-form-model-item>
    </a-form-model>
  </div>
</template>

<script>
import plan from './components/plan.vue'
export default {
    props: {
        formData: {
            required: true,
            type: Object
        },
        riskData: {
            required: true,
            type: Array
        },
        disabledAll: {
            required: true,
            type: Boolean
        }
    },
    components: {
        plan
    },
    data() {
        return {
            activeKey: ['0'],
            riskInfos: this.riskData,
            form: {},
            cradTypeCode: [],
            count: 0 // 保费计算一次成功后会+1，子组件监听此字段就不用深度监听riskinfo了
        }
    },
    watch: {
        riskData: {
            deep: true,
            handler: function(val) {
                this.count ++;
                this.riskInfos = val || [{}]
                this.form = this.formData
            }
        }
    },
    methods: {
        // 删除计划
        deleteInsurePlan(index) {
            this.riskInfos.splice(index, 1)
        },
        // 新建保障计划
        addInsurePlan() {
            this.riskInfos.push({})
        },
        // 子组件emit传递数据 {index: data}
        collectData(data) {
            for(let i in data) {
                this.riskInfos[i] = data[i]
            }
        },
        // 计算保费
        async getPremium(){
            const isValidate = await this.validateAndCollect()
            if (!isValidate) {
                return false;
            }
            const params = {
                ...this.form,
                productcode: this.form.productCode, // 调费率计算用的全小写  询价用驼峰
                riskInfos: this.riskInfos
            }
            const { data } = await this.$api.getPremiumAFP(params)
            if (data.returnCode === '00') {
                this.$refs.planForm.clearValidate()
                const { totalPremium, riskInfos } = data.content || {}
                this.riskInfos = riskInfos || [{}]
                this.form.totalPremium = totalPremium
                this.count ++
            } else {
                this.$message.error(data.returnMsg || 'error')
            }
        },
        // 收集子组件数据
        async validateAndCollect() {
            const lens = this.riskInfos.length
            for (let i = 0; i < lens; i ++) {
                const refProp = 'plan' + i;
                let isValidate = null;
                try {
                    const fn = this.$refs[refProp][0].submitHandler
                    isValidate = fn ? await fn() : true;
                } catch(error) {
                    isValidate = null;
                }
                if (!isValidate) {
                    return false;
                }
            }
            return true;
        },
        // 向父组件提交数据
        submitHandler() {
            return new Promise((resolve, reject) => {
                this.$refs.planForm.validate(async valid => {
                    if (!valid){
                        reject(new Error())
                        return false;
                    }
                    await this.getPremium(); // 保存前先调一遍计算保费接口，以防数据修改了但是未计算保费
                    const data = {
                        totalPremium: this.form.totalPremium,
                        riskInfos: JSON.stringify(this.riskInfos)
                    }
                    resolve(data)
                    this.$emit('collectData', data)
                })
            })
        },
    }
}
</script>

<style lang="scss" scoped>
::v-deep .ant-collapse {
    margin-bottom: 20px;
    .ant-collapse-item{
        border: none;
        margin-bottom: 10px;
    }
    .ant-collapse-header{
        color: #fff;
        background-color: #fe8f2d;
        font-weight: bold;
        border-radius: 10px !important;
    }
}
.insure-plan{
    // margin-bottom: 20px;
    background-color: #fff;
}
</style>